import React, { useState, useEffect } from 'react';

import { useParams, useNavigate } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhone, FaHeart, FaCamera, FaClock, FaPlay, FaStar, FaBalanceScale, FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Swal from 'sweetalert2';
import './styles.css';
import { useGlobalState } from '../../contexts/GlobalStateContext';
import PropertyCard from '../../components/FeaturedHomes/card';
// Importando as imagens das agências
import imgSafti from '../../assets/agencias/safti.webp';
import imgRemaxDragao from '../../assets/agencias/remaxdragao.webp';
import imgFocus from '../../assets/agencias/focus.webp';
import imgExp from '../../assets/agencias/exp.webp';
import imgCasaPortela from '../../assets/agencias/casadaportela.webp';
import agencyHeroImage from '../../assets/backgrounds/particular.jpg';
import paises from '../../paises.json';

const AgencyDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [agency, setAgency] = useState(null);
  const [selectedPropertyType, setSelectedPropertyType] = useState('sale');
  const [location, setLocation] = useState('');
  const [priceRange, setPriceRange] = useState({ min: '', max: '' });
  const [areaRange, setAreaRange] = useState({ min: '', max: '' });
  const [selectedTypologies, setSelectedTypologies] = useState([]);
  const [showPhone, setShowPhone] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const [showSlider, setShowSlider] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [compareDrawerActive, setCompareDrawerActive] = useState(false);
  const [compareItems, setCompareItems] = useState([]);
  const [currentProperty, setCurrentProperty] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { handleOpenLogin, handleOpenRegister } = useGlobalState();
  // Filtros adicionais
  const [propertyCategory, setPropertyCategory] = useState('all');
  const [isNewConstruction, setIsNewConstruction] = useState('all');
  const [sortBy, setSortBy] = useState('recent');
  // Lista filtrada de imóveis e contagem
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [apiProperties, setApiProperties] = useState([]);

  // Formulário de contato
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [contactMessage, setContactMessage] = useState('');
  const [charCount, setCharCount] = useState(0);
  const MAX_CHARS = 2000;

  // Base de agências (temporário - deve vir de uma API)
  const baseAgencies = [
    {
      id: 1,
      name: "Focus II, Lda",
      logo: imgFocus,
      address: "Rua D. António José Cordeiro, Nº 13 A",
      city: "Aveiro",
      postalCode: "3800-002 Glória e Vera Cruz",
      phone: "923456789",
      properties: {
        sale: { count: 677, minPrice: 19500, maxPrice: 3000000 },
        rent: { count: 22, minPrice: 4, maxPrice: 10500 }
      },
      date: "27.11.2014",
      description: "Somos uma agência imobiliária dedicada a oferecer as melhores soluções para nossos clientes, com foco em excelência e profissionalismo.",
      stats: {
        freguesias: 45,
        propertiesForSale: 677,
        propertiesForRent: 22
      }
    },
    {
      id: 2,
      name: "SAFTI Portugal",
      logo: imgSafti,
      address: "Avenida António Augusto de Aguiar nº136, 9º andar",
      city: "Lisboa",
      postalCode: "1050-021 Avenidas Novas",
      phone: "210123456",
      properties: {
        sale: { count: 1172, minPrice: 2000, maxPrice: 30000000 },
        rent: { count: 19, minPrice: 100, maxPrice: 5000 }
      },
      date: "05.12.2019",
      description: "Uma das maiores redes imobiliárias da Europa, presente em Portugal para oferecer o melhor serviço aos nossos clientes.",
      stats: {
        freguesias: 78,
        propertiesForSale: 1172,
        propertiesForRent: 19
      }
    },
    {
      id: 3,
      name: "Casa da Portela",
      logo: imgCasaPortela,
      address: "Rua Diogo Botelho, 1890",
      city: "Porto",
      postalCode: "4150-261 Aldoar, Foz do Douro e Nevogilde",
      phone: "963456789",
      properties: {
        sale: { count: 1087, minPrice: 8000, maxPrice: 8000000 },
        rent: { count: 63, minPrice: 450, maxPrice: 8700 }
      },
      date: "27.08.2013",
      description: "Especialistas em imóveis de luxo no Porto, oferecendo um serviço personalizado e exclusivo.",
      stats: {
        freguesias: 35,
        propertiesForSale: 1087,
        propertiesForRent: 63
      }
    },
    {
      id: 4,
      name: "RE/MAX GRUPO DRAGÃO",
      logo: imgRemaxDragao,
      address: "Avenida da Boavista, nº. 3191/3195",
      city: "Porto",
      postalCode: "4100-137 Lordelo do Ouro e Massarelos",
      phone: "913456789",
      properties: {
        sale: { count: 1325, minPrice: 780, maxPrice: 36000000 },
        rent: { count: 86, minPrice: 400, maxPrice: 10000 }
      },
      date: "20.10.2021",
      description: "Parte da maior rede imobiliária do mundo, trazendo excelência e profissionalismo ao mercado português.",
      stats: {
        freguesias: 92,
        propertiesForSale: 1325,
        propertiesForRent: 86
      }
    },
    {
      id: 5,
      name: "EXP Portugal",
      logo: imgExp,
      address: "Avenida da República, 679",
      city: "Porto",
      postalCode: "4450-242 Matosinhos",
      phone: "915456789",
      properties: {
        sale: { count: 890, minPrice: 1500, maxPrice: 15000000 },
        rent: { count: 45, minPrice: 350, maxPrice: 7500 }
      },
      date: "15.03.2022",
      description: "Inovação e tecnologia a serviço do mercado imobiliário, com uma abordagem moderna e eficiente.",
      stats: {
        freguesias: 48,
        propertiesForSale: 890,
        propertiesForRent: 45
      }
    }
  ];

  // Array de imóveis de exemplo
  const properties = [
    {
      id: 1,
      image: agencyHeroImage, // Ensure a valid image is provided
      price: 295000,
      title: "Apartamento T2 Raríssimo a beira do Metro",
      location: "Baixa, Cedofeita, Porto",
      bedrooms: 2,
      bathrooms: 1,
      area: 70,
      garage: 1
    },
    {
      id: 2,
      image: agencyHeroImage, // Ensure a valid image is provided
      price: 418000,
      title: "Moradia T4 para venda",
      location: "Estrada das Machadas, Vanicelos",
      bedrooms: 4,
      bathrooms: 2,
      area: 120,
      garage: 2
    },
    {
      id: 3,
      image: agencyHeroImage, // Ensure a valid image is provided
      price: 1500000,
      title: "Apartamento T3 para venda",
      location: "Rua Dia Mundial da Criança, Carcavelos",
      bedrooms: 3,
      bathrooms: 2,
      area: 180,
      garage: 2
    },
    {
      id: 4,
      image: agencyHeroImage, // Ensure a valid image is provided
      price: 310000,
      title: "Apartamento T2 para venda",
      location: "Rua Eduarda Lapa, Sesimbra",
      bedrooms: 2,
      bathrooms: 1,
      area: 47.5,
      garage: 1
    },
    {
      id: 5,
      image: agencyHeroImage, // Ensure a valid image is provided
      price: 890000,
      title: "Moradia V5 com Vista Mar",
      location: "Avenida Marginal, Cascais",
      bedrooms: 5,
      bathrooms: 3,
      area: 320,
      garage: 2
    },
    {
      id: 6,
      image: agencyHeroImage, // Ensure a valid image is provided
      price: 225000,
      title: "Apartamento T1 Renovado",
      location: "Rua da Alegria, Porto",
      bedrooms: 1,
      bathrooms: 1,
      area: 55,
      garage: 1
    },
    {
      id: 7,
      image: agencyHeroImage, // Ensure a valid image is provided
      price: 550000,
      title: "Apartamento T3 com Varanda",
      location: "Avenida da Boavista, Porto",
      bedrooms: 3,
      bathrooms: 2,
      area: 150,
      garage: 1
    },
    {
      id: 8,
      image: agencyHeroImage, // Ensure a valid image is provided
      price: 980000,
      title: "Moradia V4 com Piscina",
      location: "Rua das Flores, Maia",
      bedrooms: 4,
      bathrooms: 3,
      area: 280,
      garage: 2
    },
    {
      id: 9,
      image: agencyHeroImage, // Ensure a valid image is provided
      price: 195000,
      title: "Estúdio Moderno",
      location: "Rua Santa Catarina, Porto",
      bedrooms: 0,
      bathrooms: 1,
      area: 45,
      garage: 1
    },
    {
      id: 10,
      image: agencyHeroImage, // Ensure a valid image is provided
      price: 750000,
      title: "Apartamento T3+1 Duplex",
      location: "Foz do Douro, Porto",
      bedrooms: 3,
      bathrooms: 2,
      area: 200,
      garage: 2
    },
    {
      id: 11,
      image: agencyHeroImage, // Ensure a valid image is provided
      price: 445000,
      title: "Apartamento T2+1 com Terraço",
      location: "Matosinhos Sul",
      bedrooms: 2,
      bathrooms: 2,
      area: 120,
      garage: 1
    },
    {
      id: 12,
      image: agencyHeroImage, // Ensure a valid image is provided
      price: 1200000,
      title: "Moradia V5 com Jardim",
      location: "Vila Nova de Gaia",
      bedrooms: 5,
      bathrooms: 3,
      area: 400,
      garage: 2
    }
  ];

  // Atualiza lista filtrada sempre que filtros mudarem via "Pesquisar" ou ao inicializar
  useEffect(() => {
    // Inicializa com mocks até vir a API
    setFilteredProperties(properties);
  }, []);

  // Carrega imóveis da API para a imobiliária atual
  useEffect(() => {
    const fetchProps = async () => {
      try {
        const agencyId = Number(id);
        if (!agencyId) return;
        const token = localStorage.getItem('auth_token');
        const res = await fetch(`${import.meta.env.VITE_URL_API}/imoveis?imobiliaria=${agencyId}`, {
          headers: {
            accept: 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {})
          }
        });
        if (!res.ok) return;
        const body = await res.json();
        const list = Array.isArray(body?.data) ? body.data : (Array.isArray(body) ? body : []);
        setApiProperties(list);
        setFilteredProperties(list);
        setCurrentPage(1);
      } catch (_) {}
    };
    fetchProps();
  }, [id]);

  // Calcular o número total de páginas
  const baseList = filteredProperties?.length ? filteredProperties : (apiProperties?.length ? apiProperties : properties);
  const totalPages = Math.ceil((baseList.length || 0) / itemsPerPage);

  // Obter os imóveis da página atual
  const getCurrentProperties = () => {
    const src = baseList;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return src.slice(startIndex, endIndex);
  };

  const handleCompareNow = () => {
    // Exige ao menos 2 itens para comparação
    if (!compareItems || compareItems.length < 2) {
      try {
        Swal.fire({ icon: 'info', title: 'Selecione mais imóveis', text: 'Escolha pelo menos 2 imóveis para comparar.' });
      } catch (_) {}
      return;
    }
    try { localStorage.setItem('compare_items', JSON.stringify(compareItems)); } catch (_) {}
    navigate('/compare', { state: { items: compareItems } });
  };

  // Função para mudar de página
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, document.querySelector('.properties-section').offsetTop - 100);
  };

  const typologyToBedrooms = (t) => {
    if (t === 'T0') return { op: 'eq', v: 0 };
    if (t === 'T1') return { op: 'eq', v: 1 };
    if (t === 'T2') return { op: 'eq', v: 2 };
    if (t === 'T3') return { op: 'eq', v: 3 };
    if (t === 'T4') return { op: 'eq', v: 4 };
    return { op: 'gte', v: 5 };
  };

  const handleSearch = () => {
    let list = [...(apiProperties?.length ? apiProperties : properties)];
    // Tipo de imóvel/categoria a partir da API quando existir
    if (propertyCategory !== 'all') {
      const q = propertyCategory.toLowerCase();
      list = list.filter(p => {
        const cat = `${p?.categoria?.nome || ''} ${p?.categoria?.tipo?.nome || ''}`.toLowerCase();
        const title = (p?.tituloIMOVEL || p?.title || '').toLowerCase();
        return cat.includes(q) || title.includes(q);
      });
    }
    // Localização (usa campos da API quando presentes)
    if (location.trim()) {
      const q = location.toLowerCase();
      list = list.filter(p => (
        `${p?.enderecoIMOVEL || ''} ${p?.cityIMOVEL || ''} ${p?.stateIMOVEL || ''} ${p?.zipcodeIMOVEL || ''} ${p?.location || ''}`
          .toLowerCase()
          .includes(q)
      ));
    }
    // Preço (API: valorIMOVEL)
    const minPrice = Number(priceRange.min);
    const maxPrice = Number(priceRange.max);
    if (!Number.isNaN(minPrice) && priceRange.min !== '') list = list.filter(p => Number(p?.valorIMOVEL ?? p?.price) >= minPrice);
    if (!Number.isNaN(maxPrice) && priceRange.max !== '') list = list.filter(p => Number(p?.valorIMOVEL ?? p?.price) <= maxPrice);
    // Área (API: metragemIMOVEL)
    const minArea = Number(areaRange.min);
    const maxArea = Number(areaRange.max);
    if (!Number.isNaN(minArea) && areaRange.min !== '') list = list.filter(p => Number(p?.metragemIMOVEL ?? p?.area) >= minArea);
    if (!Number.isNaN(maxArea) && areaRange.max !== '') list = list.filter(p => Number(p?.metragemIMOVEL ?? p?.area) <= maxArea);
    // Tipologia (API: quartosIMOVEL)
    if (selectedTypologies.length) {
      list = list.filter(p => {
        const bedrooms = Number(p?.quartosIMOVEL ?? p?.bedrooms ?? 0);
        return selectedTypologies.some(t => {
          const { op, v } = typologyToBedrooms(t);
          return op === 'eq' ? bedrooms === v : bedrooms >= v;
        });
      });
    }
    // Nova construção (placeholder)
    if (isNewConstruction !== 'all') {
      // sem dado específico por enquanto
    }
    // Ordenação
    const sorted = [...list];
    const priceOf = (p) => Number(p?.valorIMOVEL ?? p?.price ?? 0);
    const areaOf = (p) => Number(p?.metragemIMOVEL ?? p?.area ?? 0);
    if (sortBy === 'price-asc') sorted.sort((a,b)=>priceOf(a)-priceOf(b));
    else if (sortBy === 'price-desc') sorted.sort((a,b)=>priceOf(b)-priceOf(a));
    else if (sortBy === 'area-asc') sorted.sort((a,b)=>areaOf(a)-areaOf(b));
    else if (sortBy === 'area-desc') sorted.sort((a,b)=>areaOf(b)-areaOf(a));
    setFilteredProperties(sorted);
    setCurrentPage(1);
    try {
      setTimeout(() => {
        const listEl = document.querySelector('.properties-section');
        if (listEl) listEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    } catch (_) {}
  };

  const handleClear = () => {
    setPropertyCategory('all');
    setSelectedPropertyType('sale');
    setLocation('');
    setPriceRange({ min: '', max: '' });
    setAreaRange({ min: '', max: '' });
    setSelectedTypologies([]);
    setIsNewConstruction('all');
    setSortBy('recent');
    setFilteredProperties(properties);
    setCurrentPage(1);
  };

  useEffect(() => {
    const fetchAgency = async () => {
      try {
        const numericId = parseInt(id);
        if (Number.isNaN(numericId)) {
          navigate('/agencies');
          return;
        }
        const token = localStorage.getItem('auth_token');
        const res = await fetch(`${import.meta.env.VITE_URL_API}/imobiliarias/${numericId}`, {
          headers: {
            accept: 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {})
          }
        });
        if (!res.ok) {
          // fallback amigável: navega para lista
          navigate('/agencies');
          return;
        }
        const body = await res.json();
        const api = Array.isArray(body) ? (body[0] || {}) : (body?.dados || body || {});

        // Helper para normalizar URL de imagem vinda da API
        const absolutize = (src) => {
          if (!src || typeof src !== 'string') return '';
          if (src.startsWith('http') || src.startsWith('data:')) return src;
          // remove '../' e possíveis prefixos relativos
          const cleaned = src.replace(/^\.*\/+/, '').replace(/^images\//, 'images/');
          const host = (import.meta.env.VITE_PUBLIC_ASSETS_HOST || '').replace(/\/$/, '');
          const base = host || String(import.meta.env.VITE_URL_API || '').replace(/\/api\/?$/, '');
          return `${base}/${cleaned}`;
        };

        // Resolver país por código usando paises.json
        const countryNameByCode = (() => {
          const map = {};
          try {
            const continents = paises?.continents || {};
            Object.values(continents).forEach((arr) => {
              (arr || []).forEach((c) => { if (c?.code && c?.nome && !map[c.code]) map[c.code] = c.nome; });
            });
            ;['Europa', 'América Latina'].forEach((key) => {
              const arr = paises?.[key];
              (arr || []).forEach((c) => { if (c?.code && c?.nome && !map[c.code]) map[c.code] = c.nome; });
            });
          } catch (_) {}
          return map;
        })();
        const resolveCountryName = (codeOrName) => {
          if (!codeOrName) return '';
          const code = String(codeOrName).toUpperCase();
          return countryNameByCode[code] || codeOrName;
        };

        // Mapeia para a estrutura usada na UI
        const imageFromApi = absolutize(api.imagemIMOBILIARIA || '');
        const totals = api?.totaisPorTipo || {};
        const mapped = {
          id: api.codigoIMOBILIARIA || numericId,
          name: api.nomeIMOBILIARIA || 'Agência',
          logo: imageFromApi || imgFocus,
          address: api.enderecoIMOBILIARIA || 'Endereço não informado',
          city: resolveCountryName(api.paisIMOBILIARIA) || api.cidadeIMOBILIARIA || '',
          postalCode: api.cepIMOBILIARIA || '',
          phone: api.telefoneIMOBILIARIA || '',
          description: api.descricaoIMOBILIARIA || 'Descrição não disponível.',
          stats: {
            freguesias: 0,
            propertiesForSale: Number(totals.compra ?? api.imovelIMOBILIARIA) || 0,
            propertiesForRent: Number(totals.arrendar) || 0,
            propertiesForHolidays: Number(totals.ferias) || 0
          },
          date: api.dataCriacao || ''
        };
        setAgency(mapped);
      } catch (error) {
        navigate('/agencies');
      }
    };
    fetchAgency();
  }, [id, navigate]);

  if (!agency) {
    return (
      <div className="agency-details-page">
        <div className="not-found">
          <h1>Carregando...</h1>
          <p>Aguarde enquanto buscamos as informações da agência.</p>
        </div>
      </div>
    );
  }

  // Derivados de estatísticas (após garantir que agency existe)
  const holidaysCount = agency?.stats?.propertiesForHolidays ?? 0;
  const totalProperties = (agency?.stats?.propertiesForSale || 0) + (agency?.stats?.propertiesForRent || 0);

  const typologies = ['T0', 'T1', 'T2', 'T3', 'T4', 'T5+'];

  const toggleTypology = (typology) => {
    setSelectedTypologies(prev =>
      prev.includes(typology)
        ? prev.filter(t => t !== typology)
        : [...prev, typology]
    );
  };

  // Helpers para comparação
  const getPropId = (p) => String(p?.codigoIMOVEL ?? p?.idIMOVEL ?? p?.id ?? '');
  const pickPrimary = (arr) => {
    if (!Array.isArray(arr) || arr.length === 0) return null;
    const asObj = arr.find(x => x && typeof x === 'object');
    if (asObj) {
      const primary = arr.find(x => Number(x?.padraoFOTO) === 1) || arr[0];
      return primary?.urlFOTO || primary?.pathFOTO || null;
    }
    return typeof arr[0] === 'string' ? arr[0] : null;
  };
  const mapCompareView = (p) => ({
    id: getPropId(p),
    title: p?.tituloIMOVEL || p?.title || 'Sem título',
    price: p?.valorIMOVEL ?? p?.price ?? null,
    label: p?.labelvalorIMOVEL || '',
    photo: pickPrimary(p?.fotos) || agencyHeroImage,
    image: pickPrimary(p?.fotos) || agencyHeroImage,
    location: p?.enderecoIMOVEL || p?.location || '',
    bedrooms: p?.quartosIMOVEL ?? p?.bedrooms ?? '',
    bathrooms: p?.banheirosIMOVEL ?? p?.bathrooms ?? '',
    area: p?.metragemIMOVEL ?? p?.area ?? '',
    garage: p?.vagasgaragemIMOVEL ?? p?.garage ?? ''
  });

  const handleCompare = (property) => {
    const pid = getPropId(property);
    if (!pid) return;
    if (compareItems.find(item => String(item.id) === pid)) {
      setCompareItems(compareItems.filter(item => String(item.id) !== pid));
      return;
    }
    if (compareItems.length >= 4) return;
    const view = mapCompareView(property);
    setCompareItems([...compareItems, view]);
    setCompareDrawerActive(true);
  };

  const handleFavorite = (property) => {
    Swal.fire({
      title: 'Faça login para continuar',
      text: `Deseja adicionar "${property.title}" aos favoritos?`,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Fazer login',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#BA824F',
      cancelButtonColor: '#666'
    }).then((result) => {
      if (result.isConfirmed) {
        handleOpenLogin();
      }
    });
  };

  const openSlider = (property) => {
    setCurrentProperty(property);
    setShowSlider(true);
    setCurrentImageIndex(0);
  };

  const closeSlider = () => {
    setShowSlider(false);
    setCurrentProperty(null);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % 6); // Assumindo 6 imagens por imóvel
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + 6) % 6); // Assumindo 6 imagens por imóvel
  };

  const handleVideoClick = () => {
    Swal.fire({
      title: 'Video do imóvel',
      html: '<div style="padding:0 0 0 0;position:relative;"><iframe width="560" height="315" src="https://www.youtube.com/embed/Xw4LzUeyWEk?si=TRg4U_MKHkkCW1aN" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></div>',
      width: '80%',
      padding: '0',
      background: '#000',
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        container: 'video-modal-container',
        popup: 'video-modal-popup'
      }
    });
  };

  const handleCardClick = (property) => {
    navigate(`/property/${property.id}`);
  };

  // Envio de mensagem de contato
  const handleSubmitContact = async (e) => {
    e.preventDefault();
    if (!contactName || !contactEmail || !contactPhone || !contactMessage) {
      Swal.fire({ icon: 'warning', title: 'Campos obrigatórios', text: 'Preencha todos os campos marcados com *.' });
      return;
    }
    try {
      const token = localStorage.getItem('auth_token');
      if (!token) {
        const res = await Swal.fire({
          icon: 'info',
          title: 'Faça login para enviar',
          text: 'Você precisa estar autenticado para enviar mensagens.',
          showCancelButton: true,
          confirmButtonText: 'Fazer login',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#BA824F'
        });
        if (res.isConfirmed) handleOpenLogin();
        return;
      }
      const selectedAgencyId = (() => {
        const v = localStorage.getItem('selected_imobiliaria');
        return v && !Number.isNaN(Number(v)) ? Number(v) : undefined;
      })();
      const body = {
        codigoUSUARIO: 10,
        ...(selectedAgencyId ? { codigoIMOBILIARIA: selectedAgencyId } : {}),
        assuntoMENSAGEM: 'Contato via página da agência',
        conteudoMENSAGEM: `Nome: ${contactName}\nEmail: ${contactEmail}\nTelefone: ${contactPhone}\nMensagem: ${contactMessage}`,
        dataEnvioMENSAGEM: new Date().toISOString().split('T')[0],
        statusMENSAGEM: 'ativo'
      };
      const response = await fetch(`${import.meta.env.VITE_URL_API}/mensagens`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      });
      if (!response.ok) {
        const txt = await response.text();
        throw new Error(txt || 'Falha ao enviar mensagem');
      }
      Swal.fire({ icon: 'success', title: 'Mensagem enviada', text: 'Obrigado por entrar em contato!' });
      setContactName('');
      setContactEmail('');
      setContactPhone('');
      setContactMessage('');
      setCharCount(0);
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err?.message || 'Não foi possível enviar a mensagem.' });
    }
  };

  return (
    <div className="agency-details-page">
      <div className="agency-hero">
        <img src={agencyHeroImage} alt={`Banner da ${agency.name}`} />
        <div className="hero-content">
          <h1>{agency.name}</h1>
          <p>{agency.description}</p>
        </div>
      </div>

      <div className="agency-container">
        <div className="agency-header">
          <div className="agency-info">
            <div className="agency-logo">
              <img src={agency.logo} alt={agency.name} />
            </div>

            <div className="agency-main-info">
              <div className="agency-header-top">
                <h1>{agency.name}</h1>
                <div className="agency-badge">
                  <FaClock />
                  <span>NO JOVIPLANET DESDE {agency.date}</span>
                </div>
              </div>

              <div className="agency-contact-info">
                <div className="contact-group">
                  <div className="phone-section">
                    <div className="phone-number">
                      <FaPhone className="phone-icon" />
                      <span>{showPhone ? agency.phone : '*** *** ***'}</span>
                    </div>
                    <button
                      className="show-number-btn"
                      onClick={() => setShowPhone(!showPhone)}
                    >
                      {showPhone ? 'Ocultar número' : 'Mostrar número'}
                    </button>
                  </div>

                  <div className="address-section">
                    <span className="address-label">Morada da sede:</span>
                    <div className="address-content">
                      <FaMapMarkerAlt className="location-icon" />
                      <div className="address-text">
                        <p>{agency.address}</p>
                        <p>{agency.postalCode} {agency.city}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="agency-content">
          <div className="agency-details-grid">
            <div className="agency-details-left">
              <div className="agency-stats">
                <h2>Sobre nós</h2>
                <div className="stats-grid">
                  <div className="stat-item">
                    <div className="stat-value">{agency.stats.freguesias}</div>
                    <div className="stat-label">Regiões</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-value">{agency?.stats?.propertiesForSale || 0}</div>
                    <div className="stat-label">Comprar</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-value">{agency?.stats?.propertiesForRent || 0}</div>
                    <div className="stat-label">Arrendar</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-value">{holidaysCount}</div>
                    <div className="stat-label">Férias</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-value">{totalProperties}</div>
                    <div className="stat-label">Total de imóveis</div>
                  </div>
                </div>
              </div>

             {/*  <div className="agency-filters">
                <h2>A nossa oferta</h2>
                <div className="filters-grid">
                  <div className="filter-group">
                    <label>Tipo de imóvel</label>
                    <select className="filter-select" value={propertyCategory} onChange={(e)=>setPropertyCategory(e.target.value)}>
                      <option value="all">Todos os tipos de imóveis</option>
                      <option value="apartamento">Apartamento</option>
                      <option value="moradia">Moradia</option>
                      <option value="terreno">Terreno</option>
                      <option value="armazém">Armazém</option>
                    </select>
                  </div>

                  <div className="filter-group">
                    <label>Tipo de transação</label>
                    <select
                      value={selectedPropertyType}
                      onChange={(e) => setSelectedPropertyType(e.target.value)}
                      className="filter-select"
                    >
                      <option value="sale">Comprar</option>
                      <option value="rent">Arrendar</option>
                      <option value="holiday">Férias</option>
                    </select>
                  </div>

                  <div className="filter-group">
                    <label>Localização</label>
                    <div className="input-with-icon">
                      <FaMapMarkerAlt className="input-icon" />
                      <input
                        type="text"
                        placeholder="Introduzir localização"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleSearch(); } }}
                      />
                    </div>
                    <div className="location-radius">
                      <span>+ 0 km</span>
                    </div>
                  </div>

                  <div className="filter-group">
                    <label>Preço</label>
                    <div className="range-inputs">
                      <input
                        type="number"
                        min="0"
                        step="1"
                        placeholder="de"
                        value={priceRange.min}
                        onChange={(e) => setPriceRange(prev => ({ ...prev, min: e.target.value }))}
                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleSearch(); } }}
                      />
                      <span>€</span>
                      <input
                        type="number"
                        min="0"
                        step="1"
                        placeholder="até"
                        value={priceRange.max}
                        onChange={(e) => setPriceRange(prev => ({ ...prev, max: e.target.value }))}
                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleSearch(); } }}
                      />
                      <span>€</span>
                    </div>
                  </div>

                  <div className="filter-group">
                    <label>Área</label>
                    <div className="range-inputs">
                      <input
                        type="number"
                        min="0"
                        step="1"
                        placeholder="de"
                        value={areaRange.min}
                        onChange={(e) => setAreaRange(prev => ({ ...prev, min: e.target.value }))}
                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleSearch(); } }}
                      />
                      <span>m²</span>
                      <input
                        type="number"
                        min="0"
                        step="1"
                        placeholder="até"
                        value={areaRange.max}
                        onChange={(e) => setAreaRange(prev => ({ ...prev, max: e.target.value }))}
                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleSearch(); } }}
                      />
                      <span>m²</span>
                    </div>
                  </div>

                  <div className="filter-group">
                    <label>Nova construção</label>
                    <select className="filter-select" value={isNewConstruction} onChange={(e)=>setIsNewConstruction(e.target.value)}>
                      <option value="all">Nova construção</option>
                      <option value="yes">Sim</option>
                      <option value="no">Não</option>
                    </select>
                  </div>

                  <div className="filter-group full-width">
                    <label>Tipologia</label>
                    <div className="typology-buttons">
                      {typologies.map(typology => (
                        <button
                          key={typology}
                          className={`typology-btn ${selectedTypologies.includes(typology) ? 'active' : ''}`}
                          onClick={() => toggleTypology(typology)}
                        >
                          {typology}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="filter-actions">
                  <button className="btn-clear" onClick={handleClear}>Limpar filtros</button>
                  <button className="btn-search" onClick={handleSearch}>Pesquisar</button>
                </div>
              </div> */}

              <div className="properties-section">
                <div className="list-header">
                  <div className="results-count">
                    {(filteredProperties?.length || properties.length)} imóveis encontrados
                  </div>
                  <div className="sort-options">
                    <span>Ordenar por:</span>
                    <select className="sort-select" value={sortBy} onChange={(e)=>{setSortBy(e.target.value);}}>
                      <option value="recent">Data do anúncio: mais recente</option>
                      <option value="price-asc">Preço (menor para maior)</option>
                      <option value="price-desc">Preço (maior para menor)</option>
                      <option value="area-asc">Área (menor para maior)</option>
                      <option value="area-desc">Área (maior para menor)</option>
                    </select>
                  </div>
                </div>

                <div className="properties-grid">
                  {getCurrentProperties().map((property) => (
                    <PropertyCard
                      key={property.id}
                      property={property}
                      onCompare={handleCompare}
                      onViewPhotos={openSlider}
                      onViewVideo={handleVideoClick}
                      onFavorite={handleFavorite}
                    />
                  ))}
                </div>

                <div className="pagination">
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
                    <button
                      key={pageNumber}
                      className={`pagination-btn ${pageNumber === currentPage ? 'active' : ''}`}
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="agency-details-right">
              <div className="contact-form">
                <h2>Envie-nos uma mensagem</h2>
                <form onSubmit={handleSubmitContact}>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Nome*"
                      value={contactName}
                      onChange={(e)=>setContactName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      placeholder="E-mail*"
                      value={contactEmail}
                      onChange={(e)=>setContactEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group phone-input">
                    <span className="country-code">+351</span>
                    <input
                      type="tel"
                      placeholder="Número de telemóvel*"
                      value={contactPhone}
                      onChange={(e)=>setContactPhone(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <textarea
                      placeholder="Escreve uma mensagem..."
                      rows="4"
                      value={contactMessage}
                      onChange={(e)=>{
                        const v = e.target.value.slice(0, MAX_CHARS);
                        setContactMessage(v);
                        setCharCount(v.length);
                      }}
                    ></textarea>
                  </div>
                  <div className="form-footer">
                    <span className="char-counter">{charCount}/{MAX_CHARS}</span>
                    <button type="submit" className="submit-btn">
                      Enviar mensagem
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Slider Modal */}
      {showSlider && (
        <div className={`image-slider-modal ${showSlider ? 'active' : ''}`}>
          <div className="slider-content">
            <button className="slider-close" onClick={closeSlider}>
              <FaTimes />
            </button>
            <div className="slider-main">
              <img src={agencyHeroImage} alt={currentProperty?.title} />
              <button className="slider-nav slider-prev" onClick={prevImage}>
                <FaChevronLeft />
              </button>
              <button className="slider-nav slider-next" onClick={nextImage}>
                <FaChevronRight />
              </button>
              <div className="slider-counter">
                {currentImageIndex + 1} / 6
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Compare Drawer */}
      <div className={`compare-drawer ${compareDrawerActive ? 'active' : ''}`}>
        <div className="compare-drawer-header">
          <h3>Comparar Imóveis ({compareItems.length}/4)</h3>
          <button onClick={() => setCompareDrawerActive(false)}>
            <FaTimes />
          </button>
        </div>
        <div className="compare-drawer-content">
          {compareItems.map((item) => (
            <div key={item.id} className="compare-item">
              <div className="compare-item-image">
                <img src={item.photo || agencyHeroImage} alt={item.title} />
              </div>
              <div className="compare-item-info">
                <h4 title={item.title}>{item.title}</h4>
                <p>{item.price ? `${item.price} ${item.label || ''}` : ''}</p>
              </div>
              <button onClick={() => handleCompare(item)} aria-label="Remover do comparar">
                <FaTimes />
              </button>
            </div>
          ))}
        </div>
        {compareItems.length > 0 && (
          <div className="compare-drawer-actions">
            <button className="btn-clear-compare" onClick={() => setCompareItems([])}>
              Limpar
            </button>
            <button className="btn-compare-now" onClick={handleCompareNow}>
              Comparar agora
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AgencyDetails;